var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-8L8 0H2A2 2 0 00.01 2L0 14a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zm-5 3a2 2 0 11-2 2 2.006 2.006 0 012-2zm4 8H9v-1c0-1.33 2.67-2 4-2s4 .67 4 2z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDIwIDE2Ij4KICAgIDxwYXRoIGQ9Ik0yMCw2SDEyTDEwLDRINEEyLDIsMCwwLDAsMi4wMSw2TDIsMThhMi4wMDYsMi4wMDYsMCwwLDAsMiwySDIwYTIuMDA2LDIuMDA2LDAsMCwwLDItMlY4QTIuMDA2LDIuMDA2LDAsMCwwLDIwLDZaTTE1LDlhMiwyLDAsMSwxLTIsMkEyLjAwNiwyLjAwNiwwLDAsMSwxNSw5Wm00LDhIMTFWMTZjMC0xLjMzLDIuNjctMiw0LTJzNCwuNjcsNCwyWiIKICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC00KSIKICAgICAgICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIC8+Cjwvc3ZnPg==";
export { SvgUserGroup as ReactComponent };